export const osnArrowLeftIcon = {
  // eslint-disable-next-line max-len
  data: `<svg viewBox="0 0 10 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M9 1L2.41421 7.58579C1.63316 8.36684 1.63316 9.63316 2.41421 10.4142L9 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'arrow-left',
};
